/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SubscriptionSourceEnum {
    Stripe = 'stripe',
    Apple = 'apple'
}

export function SubscriptionSourceEnumFromJSON(json: any): SubscriptionSourceEnum {
    return SubscriptionSourceEnumFromJSONTyped(json, false);
}

export function SubscriptionSourceEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionSourceEnum {
    return json as SubscriptionSourceEnum;
}

export function SubscriptionSourceEnumToJSON(value?: SubscriptionSourceEnum | null): any {
    return value as any;
}

